export const copilotRouteNames = {
    askAi: 'ask-ai',
  }